import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tagLoading: false,
  tagData: [],
  tagErrorMsg: "",
  postTagsData: {}
};

const setTagLoading = (state) => {
  state.tagLoading = true;
};
const setTagError = (state, action) => {
  state.tagLoading = false;
  state.tagErrorMsg = action.payload;
};
const setTagData = (state, action) => {
  state.tagLoading = false;
  state.tagData = action.payload;
  state.tagErrorMsg = "";
};
const changeSelectedTag = (state, action) => {
  let filter = state.tagData.filter((el) => el.name === action.payload)[0];
  filter.selected = !filter.selected;
};
const setPostTags = (state, action) => {
  const {ev_id, tagList} = action.payload
  state.postTagsData[ev_id] = tagList
};
const getPostTagsSlice = createSlice({
  name: "getPostTags",
  initialState,
  reducers: {
    setTagLoading,
    setTagError,
    setTagData,
    changeSelectedTag,
    setPostTags,
  },
});

export default getPostTagsSlice.reducer;
